<template>
<div class="col-12">
    <!-- report header -->
    <div v-for="(row, headerIndex) in elements.header" :key="`rpt-head-row-${headerIndex}`" class="row">
        <div v-for="(head, labelIndex) in row" :key="`rpt-head-row-label-${labelIndex}`" :class="`form-group text-left col-${head.width} ${head.offset}`">
            <label>
                <strong>{{ `${head.label} : ${collections.header[head.column]}` }}</strong>
            </label>
        </div>
    </div>
    <!-- for non grouping element -->
    <div v-if="!elements.group">
        <table class="table table-sm">
            <thead>
                <tr>
                    <th v-for="(contentHead, headIndex) in elements.content" :key="headIndex">{{ contentHead.title }}</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(data, rowIndex) in collections.content" :key="rowIndex">
                    <td v-for="(element, colIndex) in elements.content" :key="colIndex">
                        <div>{{ (element.type === 'date') ? moment(data[element.column]).format('L') : data[element.column] }}</div>
                    </td>
                </tr>
            </tbody>
            <tfoot v-if="elements.contentFooter">
                <tr>
                    <td v-for="(foot, footIndex) in elements.contentFooter" :key="footIndex" :colspan="foot.span">
                        <div v-if="foot.bold"><strong>{{ foot.title }}</strong></div>
                        <div v-if="foot.column">{{ collections.contentFooter[foot.column] }}</div>
                    </td>
                </tr>
            </tfoot>
        </table>
    </div>
    <!-- for grouping element -->
    <div v-if="elements.group">
        <div v-for="(group, groupIndex) in collections.group" :key="groupIndex">
            <div v-for="(row, headerIndex) in elements.groupHeader" :key="`rpt-head-row-${headerIndex}`" class="row">
                <div v-for="(head, labelIndex) in row" :key="`rpt-head-row-label-${labelIndex}`" :class="`form-group text-left col-${head.width} ${head.offset}`">
                    <label>
                        <strong>{{ `${head.label} : ${group.header[head.column]}` }}</strong>
                    </label>
                </div>
            </div>
            <table class="table table-sm">
                <thead>
                    <tr>
                        <th v-for="(contentHead, headIndex) in elements.content" :key="headIndex">{{ contentHead.title }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(data, rowIndex) in group.content" :key="rowIndex">
                        <td v-for="(element, colIndex) in elements.content" :key="colIndex">
                            <div>{{ (element.type === 'date') ? moment(data[element.column]).format('L') : data[element.column] }}</div>
                        </td>
                    </tr>
                </tbody>
                <tfoot v-if="elements.contentFooter">
                    <tr>
                        <td v-for="(foot, footIndex) in elements.contentFooter" :key="footIndex" :colspan="foot.span">
                            <!-- <div v-if="!foot.column"><strong v-if="foot.bold">{{ foot.title }}</strong>{{ (!foot.bold) ? foot.title : '' }}</div> -->
                            <div><strong v-if="foot.bold">{{ (foot.column) ? group.contentFooter[foot.column] : foot.title }}</strong>{{ (!foot.bold) ? (foot.column) ? group.contentFooter[foot.column] : foot.title : '' }}</div>
                        </td>
                    </tr>
                </tfoot>
            </table>
        </div>
    </div>
</div>
</template>

<script>
export default {
    props: ['elements', 'collections']
}
</script>